/* PULL UP — price render: always show the real price. The 50% is applied only at checkout with code LOUDLIST, for confirmed subscribers. */
(function(){
  document.body.classList.remove('discount-mode');
  document.querySelectorAll('.price[data-full]').forEach(function(p){
    var s=p.querySelector('.strike'), n=p.querySelector('.now');
    if(n) n.textContent=p.dataset.full+' RON';
    if(s) s.style.display='none';
  });
})();
